import React from 'react';
import Select from 'react-select';
const opciones = [
  { value: 0, label: "" },
  { value: 1, label: "Normal" },
  { value: 2, label: "Matrícula" },
  { value: 3, label: "Viaje" }
];
const CboTipoLiq = ({ selectedValue, onChange, disabled, className }) => {
  return (

    <div className="col-lg-offset-0 col-lg-2 col-xs-12 col-sm-4">
      <div className="form-group">
        <label className='l'>Tipo Liquidación</label>

        <Select
          classNamePrefix="miSelect"

          value={opciones.find(op => op.value == selectedValue)}
          onChange={(op) =>
            onChange({
              target: {
                value: op.value
              }
            })
          }
          options={opciones}
          isDisabled={disabled}
        />
      </div>
    </div>
  );
};

export default CboTipoLiq;